// extracted by mini-css-extract-plugin
export default {"checkboxFilter":"CheckboxFilter_checkboxFilter__GARFT","labelText":"CheckboxFilter_labelText__MMBns"};